import { Button, Toolbar, WithStyles } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import withStyles from "@material-ui/core/styles/withStyles";
import * as React from "react";

import { User } from "../../models/User.model";
import DynamicIcon from "../Icons/DynamicIcon";
import { styles } from "./TopToolbar.style";

type TopToolbarProps = {
    user: User;
    isSu: boolean;
    isOnline: boolean;
    elementsToSyncCount: number;
    showNewProposition: boolean;
    showEditProfile();
    showPasswordProfile();
    onDisconnect();
    onEndSu?();
    push(path: string);
};

type TopToolbarState = {
    anchorEl: any;
};

class TopToolbar extends React.Component<TopToolbarProps & WithStyles<typeof styles>, TopToolbarState> {
    state: TopToolbarState = {
        anchorEl: null,
    };

    public render() {
        const { classes, theme, isOnline, elementsToSyncCount } = this.props;

        return (
            <Toolbar className={classes.container}>
                <Button classes={{ root: classes.button, disabled: classes.buttonsDisabled }} disabled={true}>
                    <DynamicIcon name={isOnline ? "online" : "offline"} nativeColor={theme.palette.primary.main} />
                    <span className={classes.buttonLabel}>{isOnline ? "Online" : "Offline"}</span>
                </Button>
                <Button classes={{ root: classes.button, disabled: classes.buttonsDisabled }} disabled={true}>
                    <DynamicIcon
                        name="sync"
                        nativeColor={theme.palette.primary.main}
                        iconProps={{ number: elementsToSyncCount }}
                    />
                    <span className={classes.buttonLabel}>Élément(s) à synchroniser</span>
                </Button>

                {this.props.isSu && (
                    <Button className={classes.button} onClick={() => this._onEndSuMode()}>
                        <DynamicIcon name={"switch"} nativeColor={theme.palette.primary.main} />
                        <span className={classes.buttonLabel}>Revenir au mode manager</span>
                    </Button>
                )}
                {this.props.showNewProposition && (
                <Button className={classes.button} onClick={() => this.props.push("/")}>
                    <DynamicIcon name="propal" nativeColor={theme.palette.primary.main} />
                    <span className={classes.buttonLabel}>Nouvelle proposition</span>
                </Button>
                )}
                <Button className={classes.button} aria-owns={"menu-login"} onClick={this.handleClick.bind(this)}>
                    <DynamicIcon name="account" nativeColor={theme.palette.primary.main} />
                    <span className={classes.buttonLabel}>
                        {this.props.user.firstname} {this.props.user.lastname}
                    </span>
                </Button>

                <Menu
                    className={classes.menu}
                    id="menu-login"
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleClose.bind(this)}
                >
                    <MenuItem className={classes.item} onClick={() => this._showEditProfile()}>
                        Modifier mon profil
                    </MenuItem>
                    <MenuItem className={classes.item} onClick={() => this._showPasswordProfile()}>
                        Modifier mon mot de passe
                    </MenuItem>
                    <MenuItem className={classes.item} onClick={() => this._onDisconnect()}>
                        Déconnexion
                    </MenuItem>
                </Menu>
            </Toolbar>
        );
    }
    private handleClick(event) {
        this.setState({ anchorEl: event.currentTarget });
    }

    private handleClose() {
        this.setState({ anchorEl: null });
    }

    private _showEditProfile() {
        this.handleClose();
        if (this.props.showEditProfile) {
            this.props.showEditProfile();
        }
    }
    private _showPasswordProfile() {
        this.handleClose();
        if (this.props.showPasswordProfile) {
            this.props.showPasswordProfile();
        }
    }

    private _onDisconnect() {
        this.handleClose();
        if (this.props.onDisconnect) {
            this.props.onDisconnect();
        }
    }

    private _onEndSuMode() {
        if (this.props.onEndSu) {
            this.props.onEndSu();
        }
    }
}

export default withStyles(styles, { withTheme: true })(TopToolbar);



// WEBPACK FOOTER //
// ./src/components/TopToolbar/TopToolbar.tsx